import { isDefined, isEmpty } from "@utils/var.check";

const ColorUtils = {
  // Reference: https://gist.github.com/jedfoster/7939513
  decToHex: function (decValue) {
    return decValue.toString(16);
  },
  hexToDec: function (hexValue) {
    return parseInt(hexValue, 16);
  },
  mix: function (color_1, color_2, weight) {
    if (!isDefined(weight)) {
      weight = 50;
    }

    let color = "#";

    for (let i = 0; i <= 5; i += 2) {
      // loop through each of the 3 hex pairs—red, green, and blue
      let v1 = this.hexToDec(color_1.substr(i, 2)), // extract the current pairs
        v2 = this.hexToDec(color_2.substr(i, 2)),
        // combine the current pairs from each source color, according to the specified weight
        val = this.decToHex(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));

      while (val.length < 2) {
        val = "0" + val;
      } // prepend a '0' if val results in a single digit

      color += val; // concatenate val to our new color string
    }

    return color;
  },
  // Value of 100 would mean the original colour is retained
  // The lower the value, the more the colour gets tinted
  getTintedColor: function (hexColor, weight = 20) {
    if (!isEmpty(hexColor)) {
      return this.mix(hexColor.substring(1), "ffffff", weight);
    }
    return "";
  },
  // Value of 100 would mean the original colour is retained
  // The lower the value, the more the colour gets shaded
  getShadedColor: function (hexColor, weight = 40) {
    if (!isEmpty(hexColor)) {
      return this.mix(hexColor.substring(1), "000000", weight);
    }
    return "";
  },
  /* https://stackoverflow.com/a/28056903
   * Full hex code must be provided instead of shorthand code
   */
  hexToRGB(hex, alpha) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    return alpha ? `rgba(${r},${g},${b},${alpha})` : `rgba(${r},${g},${b})`;
  },
};

export default ColorUtils;
